import { programPageActionType } from '../../actionTypes';

const initialState = {
  lenderDetails: [],
};

const programPageData = (state = initialState, action) => {
  switch (action.type) {
    case programPageActionType.GET_CREDIT_SCHEME_SUCCESS:
      return {
        ...state,
        lenderDetails: action.payload,
      };

    case programPageActionType.GET_CREDIT_SCHEME_FAILURE:
      return {
        ...state,
        lenderDetails: action.payload,
      };

    default:
      return state;
  }
};

export default programPageData;



// WEBPACK FOOTER //
// ./reducer/programPage/index.js